module.exports = __webpack_public_path__ + "img/Weapon_79.7d650c88.png";